<template>
  <footer class="footer-section">
    <div class="flex justify-between max-w-screen-lg mx-auto wrapper">
      <div class="flex flex-col footer-item menu">
        <h4 class="mb-8 mt-0 text-6 text-white title">{{ t.heyBarchetti }}</h4>
        <IconLogo class="mb-8 mt-0 text-6 text-white logo" />
        <ul class="px-0 flex flex-col gap-4">
          <li :key="route.name" v-for="route in routes">
            <a :href="route.path" class="text-4 text-white">{{ route.name }}</a>
          </li>
        </ul>
      </div>
      <div class="flex flex-col footer-item">
        <h4 class="mb-8 mt-0 text-6 text-white">{{ t.whoAreYou }}</h4>
        <p class="text-4 text-white">{{ t.barchettiGroupInfo }}</p>
      </div>
      <div class="flex flex-col footer-item social-network">
        <div class="flex flex-col gap-10">
          <IconLogo class="logo" />
          <div class="flex flex-col gap-3">
            <strong class="text-white social-text">{{ t.social }}</strong>
            <div class="flex items-center gap-4">
              <a href="https://www.facebook.com/BarchettiGroup" target="_blank"><IconFacebook /></a>
              <a href="https://www.instagram.com/barchettigroup/" target="_blank"><IconInstagram /></a>
              <a href="https://it.linkedin.com/company/gruppo-barchetti" target="_blank"><IconLinkedin /></a>
              <a href="https://www.youtube.com/c/gruppobarchetti" target="_blank"><IconYoutube /></a>
            </div>
          </div>

          <div class="flex flex-col gap-3">
            <strong class="text-white policy-text">{{ t.privacyPolicy }}</strong>
            <p class="text-white">@Barchetti {{ currentYear }}</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import IconLogo from '@/components/icons/IconLogo.vue'
import IconFacebook from '@/components/icons/IconFacebook.vue'
import IconLinkedin from '@/components/icons/IconLinkedin.vue'
import IconYoutube from '@/components/icons/IconYoutube.vue'
import IconInstagram from '@/components/icons/IconInstagram.vue'
import { langMixin } from '@/lang.js'

export default {
  name: 'FooterComponent',
  components: { IconYoutube, IconLinkedin, IconFacebook, IconLogo, IconInstagram },
  mixins: [langMixin('Common')],
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    routes() {
      return [
        {
          name: this.t.searchForCars,
          path: '#'
        },
        {
          name: this.t.sellCars,
          path: '#'
        },
        {
          name: this.t.promotions,
          path: '#'
        },
        {
          name: this.t.locationsAndContacts,
          path: '/contact'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/styles/mixins';
ul {
  list-style: none;
}

.footer-section {
  flex-shrink: 0;
  flex-wrap: wrap;
  padding: 40px 20px;
  background-color: var(--neutral-80);

  @include minScreen(lg) {
    padding: 150px 0;
  }

  .footer-item {
    width: 100%;
    &:nth-child(2) {
      display: none;
    }

    .social-text,
    .policy-text {
      font-size: 1.125rem;
      text-transform: capitalize;
    }
  }

  @include minScreen(md) {
    & {
      flex-wrap: nowrap;
    }
    .footer-item {
      flex: 0.3;
      &:nth-child(2) {
        display: flex;
      }

      &:nth-child(3) {
        align-items: flex-end;
      }
    }
  }
  @media screen and (max-width: 48rem) {
    .wrapper {
      flex-direction: column;
    }
    .menu .title {
      display: none;
    }
    .social-network {
      .logo {
        visibility: hidden;
      }
    }
  }
  @media screen and (min-width: 48rem) {
    .menu {
      .logo {
        display: none;
      }
    }
  }
}
</style>
